import LoadingButton from "@Components/common/loading-button";
import BaseFormField from "@Components/web-portal/base-form-field";
import { Actions, AppContext } from "@Context/common/general/context";
import { getAuthErrorMessage } from "@Helpers/utilities-ryan";
import useI18n from "@i18n";
import { Box, Button, CircularProgress, FormControl, Typography } from "@mui/material";
import { isArray } from "lodash-es";
import React, { useContext, useEffect, useState } from "react";
import ResponsiveAlert from "../responsive-alert";

interface IForgotPasswordForm {
  togglePasswordReset: () => void;
  togglePasswordConfirmation: () => void;
}

const ForgotPasswordForm = ({ togglePasswordReset, togglePasswordConfirmation }: IForgotPasswordForm) => {
  const { i18n } = useI18n();
  const [email, setEmail] = useState<string>();
  const { state, dispatch } = useContext(AppContext);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [errorOpen, setErrorOpen] = useState(false);
  const [actionInFlight, setActionInFlight] = useState(false);

  const handleConfirm = () => {
    setErrorOpen(false);
    setActionInFlight(true);
    dispatch({
      type: Actions.FirebaseActions.SendResetCode,
      payload: { email },
      onSuccess: () => {
        setActionInFlight(false);
      },
      onError: error => {
        //TODO: Messy assumption transforming this array into expected error format
        if (isArray(error) && error.length > 0) error = error[0];
        setErrorMessage(i18n(getAuthErrorMessage(error.code)));
        setErrorOpen(true);
      },
    });
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  useEffect(() => {
    state.auth.events.resetCodeSent.on(() => {
      togglePasswordReset();
      togglePasswordConfirmation();
    });
  }, [state.auth.events.resetCodeSent]);

  return (
    <form>
      <Typography variant="text4xl700" sx={{ color: "#000000" }}>
        {i18n("forgot.password.title")}
      </Typography>
      <Box sx={{ marginTop: "16px" }}>
        <Typography variant="textBase400" sx={{ color: "#000000" }}>
          {i18n("forgot.password.ingress")}
        </Typography>
      </Box>

      <FormControl sx={{ width: "100%", marginTop: "40px" }}>
        <ResponsiveAlert errorOpen={errorOpen} errorMessage={errorMessage} setErrorOpen={setErrorOpen} />

        <BaseFormField
          id="name"
          name="Email"
          label={i18n("forgot.password.email.label")}
          type="email"
          placeholder={i18n("forgot.password.email.placeholder")}
          required
          onChange={handleEmailChange}
        />

        <Button sx={{ marginTop: "32px" }} onClick={handleConfirm} disabled={!email || actionInFlight}>
          {actionInFlight ? <CircularProgress size={24} /> : i18n("forgot.password.send.button")}
        </Button>
      </FormControl>
    </form>
  );
};

export default ForgotPasswordForm;
